import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'
import { useStyles } from '../../styles'

export const InstallStep = () => {
  const classes = useStyles()
  return (
    <div className={classes.section}>
      <p className={classes.stepText}>
        <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-step-text" /> 1
      </p>
      <h3 className={classes.sectionTitle}>
        <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-totp-setup-1-title" />
      </h3>
      <p className={classes.sectionText}>
        <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-totp-setup-1-text" />
      </p>
    </div>
  )
}
